import { render, staticRenderFns } from "./clinicproductsgroupbytypereport.vue?vue&type=template&id=f6504164&scoped=true&"
import script from "./clinicproductsgroupbytypereport.vue?vue&type=script&lang=js&"
export * from "./clinicproductsgroupbytypereport.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./clinicproductsgroupbytypereport.vue?vue&type=style&index=1&id=f6504164&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6504164",
  null
  
)

export default component.exports